import './header.css';
import { ReactComponent as Logo } from '@/assets/logo.svg';
import { Avatar, Divider, Dropdown, Menu, Space } from '@arco-design/web-react';
import { IconHome, IconLock, IconPoweroff, IconSettings, IconUser } from '@arco-design/web-react/icon';
import { UserAPI } from '@/apis/system';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { clearUserInfo } from '@/store/userInfoSlice';
// NotificationBell temporarily disabled
// import { NotificationBell } from '@/components/NotificationBell';
import _ from "lodash";
import { useEffect, useState } from 'react';

const MenuItem = Menu.Item;

export const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const userInfo = useSelector(state => state.userInfo);
    const [selectedKeys, setSelectedKeys] = useState([]);

    const onMenuItemClick = (key) => {
        switch (key) {
            case "home":
            case "0": // "0" is the logo's MenuItem key
                navigate("/");
                break;
            case "password":
                if (userInfo.isAdmin) {
                    navigate("/management/password");
                } else {
                    navigate("/workspace/password");
                }
                break;
            case "logout":
                logout();
                break;
            case "companyProfile":
                navigate("/workspace/company/profile");
                break;
            default:
                navigate(`/${key}`);
                break;
        }
    }

    const logout = async () => {
        await UserAPI.logout();
        localStorage.removeItem("login.token");
        dispatch(clearUserInfo());
        navigate("/login");
    }


    const userProfileList = (
        <Menu onClickMenuItem={onMenuItemClick} className='profile-dropdown'>
            <MenuItem key='userInfo' className='profile-dropdown-header' disabled>
                <IconUser className='dropdown-icon' />
                <span>{_.join(_.remove([userInfo.fullName, userInfo.companyName], o => o != null), ', ')}</span>
            </MenuItem>
            {_.indexOf(userInfo.roles, "company-manager") >= 0 &&
                <>
                    <Divider style={{ margin: '4px 0' }} />
                    <MenuItem key="workspace">
                        <IconHome className='dropdown-icon' />
                        Workspace
                    </MenuItem>
                    <MenuItem key="companyProfile">
                        <IconSettings className='dropdown-icon' />
                        Company Profile
                    </MenuItem>
                </>
            }
            <Divider style={{ margin: '4px 0' }} />
            <MenuItem key="password">
                <IconLock className='dropdown-icon' />
                Change Password
            </MenuItem>
            <MenuItem key='logout' className='profile-dropdown-logout'>
                <IconPoweroff className='dropdown-icon' />
                Logout
            </MenuItem>
        </Menu>
    );

    useEffect(() => {
        const path = location.pathname.substring(1);
        if (path === "") {
            setSelectedKeys(["home"])
        } else {
            setSelectedKeys([path]);
        }
    }, [location])

    return (
        <div className='header'>
            <Menu mode='horizontal' theme='dark'
                selectedKeys={selectedKeys}
                onClickMenuItem={onMenuItemClick}>
                <MenuItem key="0" >
                    <div className='logo'>
                        <Logo className='logo-pic' />
                        <span className='logo-text'>Bee</span>
                    </div>
                </MenuItem>
                <MenuItem key='home'>Home</MenuItem>
                <MenuItem key='products' title="Products">Products
                </MenuItem>
                <MenuItem key='pricing'>Pricing</MenuItem>
                <MenuItem key='about'>About Us</MenuItem>
                <MenuItem key='contact'>Contact Us</MenuItem>
            </Menu>
            <div className="profile">
                <Space size={12}>
                    {/* NotificationBell temporarily disabled */}
                    {/* {userInfo.fullName && <NotificationBell />} */}
                    <div className='profile-avatar'>
                        {userInfo.fullName ?
                            <Dropdown droplist={userProfileList}>
                                <Avatar className='default-avatar'>
                                    <IconUser />
                                </Avatar>
                            </Dropdown>
                            :
                            <Link to="/login" className='login-link'>
                                <IconUser className='login-link-icon' />
                                Log In
                            </Link>
                        }
                    </div>
                </Space>
            </div>
        </div>
    );
}